<template>
<div>
  <checkpoint-overview :checkpoint="checkpoint">
    <div class="columns">
      <div class="column">
        <p class="has-text-weight-bold has-text-info">Standards Compliance</p>
      </div>
    </div>
    <div class="columns" v-for="finding in findings" :key="finding.id">
      <div class="column">
        <div class="is-flex justify-between">
          <p>
            <span class="has-text-weight-bold has-text-info">{{ finding.standard_section.standard.name }}</span> - {{ finding.standard_section.title }}
          </p>
          <yes-no class="tag is-rounded" :value="Boolean(finding.resolved_at)" yes-text="Compliant" no-text="Not Compliant"/>
        </div>
      </div>
    </div>
  </checkpoint-overview>  
</div>  
</template>
<script>
import { first } from 'lodash'
import CheckpointOverview from '@/components/CheckpointOverview'

export default {

  components: {
    CheckpointOverview
  },
  
  props: {
    checkpointId: Number|String,
    findings: {
      type: Array,
      default: () => ([])
    }
  },

  computed: {
    checkpoint() {
      return first(this.findings.map(finding => finding.checkpoint))
    }
  }

}
</script>